/* eslint-disable react/prop-types */
/* eslint-disable no-undef */
import React, { Suspense, useContext } from 'react'
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Outlet,
    Navigate,
    useLocation,
} from 'react-router-dom'
import { Layout, Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import Login from './pages/Login'
import ForgotPassword from './pages/ForgotPassword'
import { SettingContext } from './store/SettingProvider'
import { AuthContext } from './store/AuthProvider'
import { AnalysisContext } from './store/AnalysisProvider'
import { DashboardContext as TimeLineContext } from './store/TimeLineDashboardProvider'
import Sidebar from './components/Sidebar'
import Header from './components/Header'
import Footer from './components/Footer'
import AnalysisSidebar from './components/AnalysisSidebar'
import 'antd/dist/reset.css'
import './css/ant-override.css'
import './css/var.css'
import './css/main.css'
import './css/rwd.css'
import './css/dark.css'

const Dashboard = React.lazy(() => import('./pages/dashboard'))
const TimeLineDashboard = React.lazy(() => import('./pages/TimeLineDashboard'))
const NotFound = React.lazy(() => import('./pages/NotFound'))
const NotFoundInside = React.lazy(() => import('./pages/NotFoundInside'))
const ChangePassword = React.lazy(() => import('./pages/ChangePassword'))
const Device = React.lazy(() => import('./pages/Device'))
const DeviceView = React.lazy(() => import('./pages/DeviceView'))
const Analysis = React.lazy(() => import('./pages/Analysis'))
const ContractConfigView = React.lazy(() =>
    import('./pages/ContractConfigView')
)
const Settings = React.lazy(() => import('./pages/Settings'))
const Abnormal = React.lazy(() => import('./pages/Abnormal'))
const AbnormalView = React.lazy(() => import('./pages/AbnormalView'))
const GreenEnergyReport = React.lazy(() => import('./pages/GreenEnergyReport'))
const GreenEnergyReportMeterNumber = React.lazy(() =>
    import('./pages/GreenEnergyReportMeterNumber')
)
const Accountstatement = React.lazy(() => import('./pages/Accountstatement'))
const GreenEnergyRealTime = React.lazy(() =>
    import('./pages/GreenEnergyRealTime')
)
const EmsReport = React.lazy(() => import('./pages/EmsReport'))
const DemandResponse = React.lazy(() => import('./pages/DemandResponse'))
const VPPHealth = React.lazy(() => import('./pages/VPPHealth'))
const EmsDispatch = React.lazy(() => import('./pages/EMSDispatch'))
const antIcon = (
    <LoadingOutlined
        style={{
            fontSize: 48,
        }}
        spin
    />
)

function App() {
    const { customTimeLineMode } = useContext(TimeLineContext)
    const { user } = useContext(AuthContext)
    // 獲取用戶選單
    const userMenus = user?.menuList || []

    const renderRoute = (path, Component) => {
        return userMenus.some((menu) => menu.menuPath === path) ? (
            <Route path={path} element={<Component />} />
        ) : null
    }

    const commonRoutes = (
        <>
            {renderRoute('/', Dashboard)}
            {renderRoute('/changepassword', ChangePassword)}
            {renderRoute('/device', Device)}
            {renderRoute('/device/:id', DeviceView)}
            {renderRoute('/controls', NotFoundInside)}
            {renderRoute('/analysis', Analysis)}
            {renderRoute('/contractconfig', ContractConfigView)}
            {renderRoute('/abnormal', Abnormal)}
            {renderRoute('/abnormal/:id', AbnormalView)}
            {renderRoute('/greenenergyrealtime', GreenEnergyRealTime)}
            {renderRoute('/greenenergyreport', GreenEnergyReport)}
            {renderRoute(
                '/greenenergyreportmeternumber',
                GreenEnergyReportMeterNumber
            )}
            {renderRoute(
                '/greenenergyreportmeternumber/:id',
                GreenEnergyReportMeterNumber
            )}
            {renderRoute('/accountstatement', Accountstatement)}
            {renderRoute('/emsreport', EmsReport)}
            {renderRoute('/demandresponse', DemandResponse)}
            {renderRoute('/vpphealth', VPPHealth)}
            {renderRoute('/emsdispatch', EmsDispatch)}
            {renderRoute('/settings', Settings)}
            {userMenus.some(
                (menu) => menu.menuPath === '/timelinedashboard'
            ) && (
                <Route
                    path="/timelinedashboard"
                    element={
                        customTimeLineMode ? (
                            <TimeLineDashboard />
                        ) : (
                            <Navigate to="/" />
                        )
                    }
                />
            )}
        </>
    )

    return (
        <Router>
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/forgotpassword" element={<ForgotPassword />} />
                <Route path="/" element={<NavWrapper />}>
                    {commonRoutes}
                    <Route path="/*" element={<NotFoundInside />} />
                </Route>
                <Route path="/*" element={<NotFound />} />
            </Routes>
        </Router>
    )
}

function NavWrapper() {
    const { dark } = useContext(SettingContext)
    const { user } = useContext(AuthContext)
    const { isDraggable } = useContext(AnalysisContext)
    const sidebar = isDraggable ? <AnalysisSidebar /> : <Sidebar />
    const location = useLocation()
    if (!user) return <Navigate to="/login" />

    const userMenus = user?.menuList || []

    // 當使用者的路由menu清單沒有"/"時，導入有清單的選項
    if (
        location.pathname === '/' &&
        !userMenus.some((menu) => menu.menuPath === '/')
    ) {
        return (
            <Navigate
                to={
                    userMenus.some(
                        (menu) => menu.menuPath === '/greenenergyrealtime'
                    )
                        ? '/greenenergyrealtime'
                        : '/greenenergyreport'
                }
                replace
            />
        )
    }

    return (
        <Layout className={`app-layout ${dark ? 'dark' : ''}`}>
            {sidebar}
            <Layout className="app-background">
                <Header />
                <Suspense
                    fallback={
                        <div className="app-content loading">
                            <Spin indicator={antIcon} />
                        </div>
                    }
                >
                    <Outlet />
                </Suspense>
                <Footer />
            </Layout>
        </Layout>
    )
}

export default App
